import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DefaultBox from './placeholder-box@2x.png';
import ReviewButton from './ReviewButton';

const BoxImage = ({
  imageURL, showReviewButton, isMobile, isChallenge,
}) => (showReviewButton ? (
  <div className="review-container">
    <ImgTag imageURL={imageURL} isChallenge={isChallenge} isMobile={isMobile} />
    <ReviewButton />
  </div>
) : (
  <ImgTag imageURL={imageURL} isChallenge={isChallenge} isMobile={isMobile} />
));

BoxImage.defaultProps = {
  imageURL: null,
  showReviewButton: false,
  isMobile: false,
  isChallenge: false,
};

BoxImage.propTypes = {
  imageURL: PropTypes.string,
  showReviewButton: PropTypes.bool,
  isMobile: PropTypes.bool,
  isChallenge: PropTypes.bool,
};

const ImgTag = ({
  imageURL, isMobile, isChallenge,
}) => {
  const [isImageFailing, setIsImageFailing] = useState(false);
  const imgClassName = `${isChallenge ? 'challenge-' : ''}mybox-image${isChallenge && !isMobile ? '-desktop' : ''}`;
  return imageURL && !isImageFailing ? (
    <img
      src={imageURL}
      alt="Current box"
      className={imgClassName}
      onError={() => setIsImageFailing(true)}
    />
  ) : (
    <img src={DefaultBox} alt="Current box" className={imgClassName} />
  );
};

ImgTag.defaultProps = {
  imageURL: null,
  isMobile: false,
  isChallenge: false,
};

ImgTag.propTypes = {
  imageURL: PropTypes.string,
  isMobile: PropTypes.bool,
  isChallenge: PropTypes.bool,
};

export default BoxImage;
